export const formatOption = <Option>(option?: Option) => {
  if (option === undefined || option === null) {
    return ''
  }

  if (typeof option === 'string') {
    return option
  }

  if (typeof option === 'number') {
    return `${option}`
  }

  throw new Error('Please provide a getOptionId function to handle this option case in SelectBox. ')
}

export const createOptionMap = <Option>(
  options: Option[] | readonly Option[] | undefined,
  getOptionId: (option: Option) => string
): Map<string, Option> => {
  if (!options) return new Map()

  const map = new Map<string, Option>()
  options.forEach((option) => {
    map.set(getOptionId(option), option)
  })
  return map
}
